module.exports = __webpack_public_path__ + "static/img/SJCFLogo.c586392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/SJCFLogo.png
// module id = ysdM
// module chunks = 0